// extracted by mini-css-extract-plugin
export default {"mark":"D1xXio"};